export const MyApi = {
  BASE_URL: "https://kashijourneys.com/kashiapi/api/",
  SECRET_KEY: "123456789",

  SITE_SETTING: "site-setting",
  CAT_MENU: "cat-menu",
  BANNER_LIST: "bannerlist",
  CMS_PAGE: "pages/", 


  TOUR_PACKAGES: "products-with-parent-category",
  // POPULAR_TOUR: "popular-tour",
  LOCAL_TOUR: "local-tour",
  TOUR_LIST: "tours-list", 
  TOUR_DETAILS: "tour-details",

  CLIENTS_LOGO: "ClientsLogo",
  CONTACT_PAGE: "contact-page",
 
 
  GALLERY_CAT: "gallery-cat",
  VIDEO_GALL: "video-gallery",
  TESTIMONIAL_API: "submit-testimonial",
  TESTIMONIAL_GET: "get-testimonials",
  // GALLERY_VIEW: "gallery-list",
  
};
